import { ActionType, Assign } from "@redotech/redo-model/return-flow/action";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export type AssignState = { user: { id: string; name: string } };

export const ASSIGN = (
  Details: React.ComponentType<RuleTypeDetailsProps<AssignState>>,
): ActionTypeSetup<AssignState, Assign> => ({
  name: "Assign to agent",
  description() {
    return "Assign the ticket to an agent";
  },
  Details(props: RuleTypeDetailsProps<AssignState>) {
    return React.createElement(Details, props);
  },
  empty: { user: { id: "", name: "" } },
  fromModel(model) {
    return { user: model.user };
  },
  toModel(state) {
    return { type: ActionType.Assign, user: state.user };
  },
  valid(state) {
    return !!state.user?.id;
  },
});
